export default __webpack_public_path__ + "static/media/battleMusic.31fc31cf.mp3";